// Public API barrel for the Language Analyzer framework (ARCHITECTURE.md §6).

export * from "./types.js";
export * from "./project-analyzer.js";
export * from "./registry.js";
export * from "./built-in/typescript.js";
export * from "./built-in/typescript-project-analyzer.js";
export * from "./built-in/yaml.js";

import { TypeScriptAnalyzer } from "./built-in/typescript.js";
import { TypeScriptProjectAnalyzer } from "./built-in/typescript-project-analyzer.js";
import { YamlAnalyzer } from "./built-in/yaml.js";
import { AnalyzerRegistry } from "./registry.js";

/**
 * Create an AnalyzerRegistry pre-populated with the built-in analyzers
 * (TypeScript first, then YAML) per ARCHITECTURE.md §6.4. Registration order
 * establishes extension priority — the TypeScript analyzer is registered first.
 *
 * The TypeScript ProjectAnalyzer (proposal §3.5) is registered for the
 * cross-file resolution pass that rewrites bare-name `calls` / `type_reference`
 * edges to full symbolIds.
 */
export function createDefaultRegistry(): AnalyzerRegistry {
  const registry = new AnalyzerRegistry();
  registry.register(new TypeScriptAnalyzer());
  registry.register(new YamlAnalyzer());
  registry.registerProjectAnalyzer(new TypeScriptProjectAnalyzer());
  return registry;
}
